import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { addSlots, getSchools } from "../utils/firebaseUtils";

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const theme = createTheme();

const useStyles = makeStyles({
  hover: {
    "&:hover": {
      borderColor: "blue",
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
  },
});

const name_dict: any = {
  UPenn: require("../images/Upenn.png").default,
  Drexel: require("../images/Drexel.png").default,
  UF: require("../images/UF.jpeg").default,
  FSU: require("../images/FSU.jpeg").default,
  "Wayne State": require("../images/WayneState.jpeg").default,
  "Michigan State": require("../images/MSU.png").default,
  Duke: require("../images/Duke.png").default,
  LECOM: require("../images/LECOM.png").default,
  UM: require("../images/UM.png").default,
  USF: require("../images/USF.png").default,
  FIU: require("../images/FIU.png").default,
  "George Washington": require("../images/GW.png").default,
  "VCOM DO": require("../images/VCOM.jpeg").default,
  "Georgia PCOM": require("../images/PCOM.jpeg").default,
  "Nova DO": require("../images/Nova.png").default,
  "Wash U": require("../images/WashU.png").default,
  UCF: require("../images/UCF.jpeg").default,
  "Nova MD": require("../images/Nova.png").default,
  Vanderbilt: require("../images/Vanderbilt.png").default,
  "Wake Forest": require("../images/WF.png").default,
  OUWB: require("../images/OUWB.jpeg").default,
  "Mayo Clinic": require("../images/MayoClinic.png").default,
  FAU: require("../images/FAU.png").default,
  Loyola: require("../images/Loyola.png").default,
  Rush: require("../images/Rush.jpeg").default,
};

interface props {
  user: any;
  setUser: Function;
}

function Main({ user, setUser }: props) {
  let navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("AM");

  const [amSchools, setAmSchools] = useState<any[]>([]);
  const [pmSchools, setPmSchools] = useState<any[]>([]);

  const [amFirst, setAmFirst] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });
  const [amSecond, setAmSecond] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });
  const [amThird, setAmThird] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });
  const [amFourth, setAmFourth] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });

  const [pmFirst, setPmFirst] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });
  const [pmSecond, setPmSecond] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });
  const [pmThird, setPmThird] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });
  const [pmFourth, setPmFourth] = useState({
    schoolName: "",
    time: "",
    category: "",
    id: "",
  });

  const [amIS, setAmIS] = useState<any[]>([]);
  const [amOOS, setAmOOS] = useState<any[]>([]);
  const [amDO, setAmDO] = useState<any[]>([]);

  const [amNumIS, setAmNumIS] = useState<number>(0);
  const [amNumOOS, setAmNumOOS] = useState<number>(0);
  const [amNumDO, setAmNumDO] = useState<number>(0);

  const [pmIS, setPmIS] = useState<any[]>([]);
  const [pmOOS, setPmOOS] = useState<any[]>([]);
  const [pmDO, setPmDO] = useState<any[]>([]);

  const [pmNumIS, setPmNumIS] = useState<number>(0);
  const [pmNumOOS, setPmNumOOS] = useState<number>(0);
  const [pmNumDO, setPmNumDO] = useState<number>(0);

  const amDict: any = {
    "In-State": [amIS, setAmIS, amNumIS, setAmNumIS],
    "Out-Of-State": [amOOS, setAmOOS, amNumOOS, setAmNumOOS],
    DO: [amDO, setAmDO, amNumDO, setAmNumDO],
  };

  const pmDict: any = {
    "In-State": [pmIS, setPmIS, pmNumIS, setPmNumIS],
    "Out-Of-State": [pmOOS, setPmOOS, pmNumOOS, setPmNumOOS],
    DO: [pmDO, setPmDO, pmNumDO, setPmNumDO],
  };

  const setDict: any = {
    First: [amFirst, setAmFirst],
    Second: [amSecond, setAmSecond],
    Third: [amThird, setAmThird],
    Fourth: [amFourth, setAmFourth],
    Fifth: [pmFirst, setPmFirst],
    Sixth: [pmSecond, setPmSecond],
    Seventh: [pmThird, setPmThird],
    Eigth: [pmFourth, setPmFourth],
  };

  const timeDict: any = {
    AM: amDict,
    PM: pmDict,
  };

  const signupDict: any = {
    First: "breakoutOneSigns",
    Second: "breakoutTwoSigns",
    Third: "breakoutThreeSigns",
    Fourth: "breakoutFourSigns",
    Fifth: "breakoutOneSigns",
    Sixth: "breakoutTwoSigns",
    Seventh: "breakoutThreeSigns",
    Eigth: "breakoutFourSigns",
  };

  useEffect(() => {
    const id = localStorage.getItem("id");
    if (id === null) {
      navigate("/signup", { replace: true });
    }
    if (
      !(user.hasOwnProperty("amSessionsIds") && user.amSessionsIds.length === 4)
    ) {
      getSchools().then(({ amSchools: a, pmSchools: p }) => {
        setAmSchools(a);
        setPmSchools(p);

        let is: any[] = [];
        let oos: any[] = [];
        let do_: any[] = [];

        a.forEach((school) => {
          if (school.category === "In-State") {
            is.push(school);
          } else if (school.category === "Out-Of-State") {
            oos.push(school);
          } else {
            do_.push(school);
          }
        });

        setAmIS(is);
        setAmOOS(oos);
        setAmDO(do_);

        is = [];
        oos = [];
        do_ = [];

        p.forEach((school) => {
          if (school.category === "In-State") {
            is.push(school);
          } else if (school.category === "Out-Of-State") {
            oos.push(school);
          } else {
            do_.push(school);
          }
        });

        setPmIS(is);
        setPmOOS(oos);
        setPmDO(do_);
      });
    }
  }, []);

  interface SchoolCardProps {
    school: any;
    session: string;
    time: string;
  }

  const SchoolCard = ({ school, session, time }: SchoolCardProps) => {
    const classes = useStyles();

    const [clicked, setClicked] = useState(false);
    return (
      <div
        className={classes.hover}
        style={{
          minWidth: 120,
          height: 170,
          padding: 4,
          margin: 8,
          borderWidth: 1,
          borderStyle: "solid",
          borderRadius: 8,
        }}
      >
        {clicked ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              onClick={() => {
                const set = timeDict[time][school.category];
                // remove from array
                set[1](
                  set[0].filter(
                    (item: any) => item.schoolName !== school.schoolName
                  )
                );
                // increment num
                set[3](set[2] + 1);
                // set selected school
                setDict[session][1](school);
                console.log(set);
              }}
            >
              Select
            </Button>
            <Button
              onClick={() => {
                setClicked(false);
              }}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <div
            onClick={() => {
              console.log(school, signupDict, session);
              setClicked(true);
            }}
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: 90, height: 90 }}>
              <img
                style={{ width: 90, height: 90 }}
                src={name_dict[school.schoolName]}
                alt="Logo"
              />
            </div>
            <div>
              <Typography variant="body2">{school.schoolName}</Typography>
              <Typography variant="body2">{school.category}</Typography>
              {/* <Typography
                variant="caption"
                style={{
                  color:
                    50 - school[signupDict[session]] < 10 ? "red" : "black",
                }}
              >
                {50 - school[signupDict[session]]} Spots Remaining
              </Typography> */}
            </div>
          </div>
        )}
      </div>
    );
  };

  interface SchoolSelectProps {
    isSchools: any[];
    oosSchools: any[];
    doSchools: any[];
    session: string;
    time: string;
  }

  const SchoolSelect = ({
    isSchools,
    oosSchools,
    doSchools,
    session,
    time,
  }: SchoolSelectProps) => {
    return (
      <>
        {setDict[session][0].schoolName.length > 1 ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>
              You have selected {setDict[session][0].schoolName}
            </Typography>
            <Button
              onClick={() => {
                const school = setDict[session][0];
                const set = timeDict[time][school.category];
                // add back school
                set[1]([...set[0], school]);
                // // decrement num
                set[3](set[2] - 1);
                // // clear selected school
                setDict[session][1]({
                  schoolName: "",
                  time: "",
                  category: "",
                  id: "",
                });
                console.log(set);
              }}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <div
            style={{
              minHeight: 140,
              width: "100%",
              display: "flex",
              flexDirection: "row",
              overflowY: "auto",
            }}
          >
            {timeDict[time]["In-State"][2] < 2 &&
              isSchools.map((school: any, index) => {
                return (
                  <>
                    {school[signupDict[session]] < 30 ? (
                      <SchoolCard
                        key={index}
                        school={school}
                        session={session}
                        time={time}
                      />
                    ) : (
                      <div />
                    )}
                  </>
                );
              })}
            {timeDict[time]["Out-Of-State"][2] < 2 &&
              oosSchools.map((school: any, index) => {
                return (
                  <>
                    {school[signupDict[session]] < 30 ? (
                      <SchoolCard
                        key={index}
                        school={school}
                        session={session}
                        time={time}
                      />
                    ) : (
                      <div />
                    )}
                  </>
                );
              })}
            {timeDict[time]["DO"][2] < 2 &&
              doSchools.map((school: any, index) => {
                return (
                  <>
                    {school[signupDict[session]] < 30 ? (
                      <SchoolCard
                        key={index}
                        school={school}
                        session={session}
                        time={time}
                      />
                    ) : (
                      <div />
                    )}
                  </>
                );
              })}
          </div>
        )}
      </>
    );
  };

  interface ScheduleRowProps {
    time: string;
    item: string;
  }

  const ScheduleRow = ({ time, item }: ScheduleRowProps) => {
    return (
      <div
        style={{
          width: "50%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography>{time}</Typography>
        <Typography>{item}</Typography>
      </div>
    );
  };

  const onCancel = () => {
    setModalOpen(false);
    setModalMode("AM");
  };

  return (
    <div
      style={{
        backgroundImage:
          "linear-gradient(217deg, rgba(234,4,2,.8), rgba(3,234,45,0) 70.71%), linear-gradient(127deg, rgba(2,34,64,.8), rgba(0,233,111,0) 70.71%), linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%)",
        backgroundRepeat: "repeat",
        backgroundSize: "cover",
        height: 880
      }}
    >
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="md">
          <div style={{ height: 24 }} />
          <Card sx={{ minWidth: 275 }}>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Grid container>
                  <Grid item xs>
                    <Typography variant="h5" component="h3">
                      Dashboard
                    </Typography>
                  </Grid>
                  <Grid item>
                    {user.admin && (
                      <Button
                        onClick={() => {
                          navigate("/admin", { replace: true });
                        }}
                      >
                        {"View Admin Panel"}
                      </Button>
                    )}
                  </Grid>
                </Grid>
                <Typography>Welcome, {user.firstName}.</Typography>
              </div>
            </div>
          </Card>
          <div style={{ height: 24 }} />
          <Card sx={{ minWidth: 275 }}>
            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Grid container>
                  <Grid item xs>
                    <Typography variant="h5" component="h3">
                      Schedule
                    </Typography>
                  </Grid>
                </Grid>
                <div style={{ height: 12 }} />
                {user.hasOwnProperty("amSessionsIds") &&
                user.amSessionsIds.length === 4 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <ScheduleRow time="9:00-9:50 AM" item="Introductions and Keynote" />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="10:00-10:25 AM"
                      item={user.amSessionsNames[0]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="10:30-10:55 AM"
                      item={user.amSessionsNames[1]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="11:00-11:25 AM"
                      item={user.amSessionsNames[2]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="11:30-11:55 PM"
                      item={user.amSessionsNames[3]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="12:00-1:55 PM"
                      item="Tabling Session"
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="2:00-2:25 PM"
                      item={user.pmSessionsNames[0]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="2:30-2:55 PM"
                      item={user.pmSessionsNames[1]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="3:00-3:25 PM"
                      item={user.pmSessionsNames[2]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="3:30-3:55 PM"
                      item={user.pmSessionsNames[3]}
                    />
                    <div style={{ height: 12 }} />
                    <ScheduleRow
                      time="4:00-5:00 PM"
                      item="Closing Remarks/Med Student Panel"
                    />
                    <div style={{ height: 12 }} />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Typography>
                      It seems like you have not signed up for any sessions yet!
                    </Typography>
                    <Button onClick={() => setModalOpen(true)}>
                      Sign Up Now
                    </Button>
                    <Dialog open={modalOpen} onClose={() => onCancel()}>
                      <DialogTitle>{"Sign Up for Sessions"}</DialogTitle>
                      <DialogContent dividers>
                        <div
                          style={{ minWidth: 500, height: 500, padding: 20 }}
                        >
                          {modalMode === "AM" ? (
                            <>
                              <Typography>Session 1 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={amIS}
                                oosSchools={amOOS}
                                doSchools={amDO}
                                session="First"
                                time="AM"
                              />
                              <div style={{ height: 12 }} />
                              <Typography>Session 2 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={amIS}
                                oosSchools={amOOS}
                                doSchools={amDO}
                                session="Second"
                                time="AM"
                              />
                              <div style={{ height: 12 }} />
                              <Typography>Session 3 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={amIS}
                                oosSchools={amOOS}
                                doSchools={amDO}
                                session="Third"
                                time="AM"
                              />
                              <div style={{ height: 12 }} />
                              <Typography>Session 4 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={amIS}
                                oosSchools={amOOS}
                                doSchools={amDO}
                                session="Fourth"
                                time="AM"
                              />
                            </>
                          ) : (
                            <>
                              <Typography>Session 1 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={pmIS}
                                oosSchools={pmOOS}
                                doSchools={pmDO}
                                session="Fifth"
                                time="PM"
                              />
                              <div style={{ height: 12 }} />
                              <Typography>Session 2 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={pmIS}
                                oosSchools={pmOOS}
                                doSchools={pmDO}
                                session="Sixth"
                                time="PM"
                              />
                              <div style={{ height: 12 }} />
                              <Typography>Session 3 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={pmIS}
                                oosSchools={pmOOS}
                                doSchools={pmDO}
                                session="Seventh"
                                time="PM"
                              />
                              <div style={{ height: 12 }} />
                              <Typography>Session 4 Select</Typography>
                              <div style={{ height: 12 }} />
                              <SchoolSelect
                                isSchools={pmIS}
                                oosSchools={pmOOS}
                                doSchools={pmDO}
                                session="Eigth"
                                time="PM"
                              />
                            </>
                          )}
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => onCancel()}>Cancel</Button>
                        {modalMode === "PM" && (
                          <Button onClick={() => setModalMode("AM")}>
                            Go to AM
                          </Button>
                        )}
                        {modalMode === "AM" && (
                          <Button onClick={() => setModalMode("PM")}>
                            Go to PM
                          </Button>
                        )}
                        <Button
                          onClick={() => {
                            addSlots(
                              [amFirst, amSecond, amThird, amFourth],
                              user.id,
                              "AM"
                            );
                            addSlots(
                              [pmFirst, pmSecond, pmThird, pmFourth],
                              user.id,
                              "PM"
                            ).then(() => {
                              window.location.reload();
                            });
                            setModalOpen(false);
                          }}
                          disabled={
                            amFirst.schoolName.length < 1 ||
                            amSecond.schoolName.length < 1 ||
                            amThird.schoolName.length < 1 ||
                            amFourth.schoolName.length < 1 ||
                            pmFirst.schoolName.length < 1 ||
                            pmSecond.schoolName.length < 1 ||
                            pmThird.schoolName.length < 1 ||
                            pmFourth.schoolName.length < 1
                          }
                        >
                          Sign Up!
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                )}
              </div>
            </div>
          </Card>
          <div style={{ height: 24 }} />
        </Container>
      </ThemeProvider>
    </div>
  );
}

export default Main;
